export default __webpack_public_path__ + "static/media/calculator-moneystack4.8756c852.png";